export default __webpack_public_path__ + "static/media/tabby_magic.11bae068.png";